/**
 * PAD unlock helpers for Diagnostic Decision completion.
 *
 * SLaM Path 1 unlocks PAD at the end of CI so the Lead can run PAD before DD.
 * When DD later completes, we must not regress PAD that is already in progress
 * or completed — the same guard MDT Plan already uses.
 */

/**
 * @param {Object|null} patientDataModel
 * @returns {boolean} True when PAD is still locked (or unset) and may be unlocked.
 */
export function shouldUnlockPadOnDdComplete(patientDataModel) {
  const padStatus =
    patientDataModel?.dataModel?.['5_postAssessmentDiscussion']?.status;
  return !padStatus || padStatus === 'locked';
}

/**
 * Resolve the PAD status to write on DD completion, or null to leave PAD alone.
 *
 * @param {Object|null} patientDataModel
 * @param {boolean} unlockToNotStarted - True when this DD outcome should unlock PAD
 *   (ADHD flow or SSI-always orgs). False would lock PAD for non-ADHD paths —
 *   but only when PAD is still locked; never re-lock an open PAD.
 * @returns {'notStarted'|'locked'|null}
 */
export function resolvePadStatusOnDdComplete(patientDataModel, unlockToNotStarted) {
  if (!shouldUnlockPadOnDdComplete(patientDataModel)) {
    return null;
  }
  return unlockToNotStarted ? 'notStarted' : 'locked';
}
